<!--  -->
<template>
  <div class="box">
    <el-form ref="linkobj" :model="linkobj" :rules="rules" class="demo-ruleForm">
      <el-form-item prop="written">
        <div class="choosecover chooseitem">

          <div class="text_wei">
            文字内容：
          </div>
          <el-input v-model.trim="linkobj.written" placeholder="请输入展示的文字" />
        </div>
      </el-form-item>
      <el-form-item prop="linkwritten">
        <div class="choosecover chooseitem">
          <div class="text_wei">
            链接内容：
          </div>
          <el-input
            v-model.trim="linkobj.linkwritten"
            placeholder="https://baidu.com"
          />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button @click="linkbtn('linkobj')">确定</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="choosecover chooseitem">

      <div class="text_wei">
        文字内容：
      </div>
      <el-input v-model.trim="linkobj.written" placeholder="请输入展示的文字" />
    </div>

    <div class="btn_determine">
      <el-button @click="linkbtn">确定</el-button>
    </div> -->

  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入url'))
      } {
        const urlregex = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
        if (!urlregex.test(value)) {
          callback(new Error('url格式不正确！'))
        } else {
          callback()
        }
      }
    }
    return {
      linkobj: {
        written: '',
        linkwritten: ''
      },
      rules: {
        written: [
          { required: true, message: '文字内容不能为空', trigger: 'blur' }
        ],
        linkwritten: [
          { validator: validatePhone, trigger: 'blur' }

        ]
      },
      id: null // 平台id
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    linksend(id) {
      // 平台id
      this.id = id
      console.log('id', id)
    },
    linkbtn(linkobj) {
      // if (this.linkobj.written === '') {
      //   this.$message.error('请输入文字内容')
      //   return
      // }
      // if (this.linkobj.linkwritten === '') {
      //   this.$message.error('请输入链接内容')
      //   return
      // }
      this.$refs[linkobj].validate((valid) => {
        if (valid) {
          console.log('submit!')
          this.$emit('linkbtn', this.linkobj)
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.$emit('linkbtn', this.linkobj)
    }
  }
}
</script>
<style scoped lang="scss">
/* @import url(); 引入css类 */
.choosecover{
  display: flex;
  align-items: center;
}
.chooseitem{
  margin-bottom: 30px;
}
.text_wei {
  flex-shrink: 0;
}
.btn_determine{
  margin-top: 30px;
  text-align: right;
}
::v-deep .el-form-item__content  .el-form-item__error{
  top:80%;
  left:70px;
  // font-size: 16px;
}
</style>
